// utils/getRepresentativeWord.js

export function getRepresentativeWord(rubro = '') {
    const mappings = [
      { pattern: /tecnolog/i, rep: "Tecnología" },
      { pattern: /panific/i, rep: "Panificados" },
      { pattern: /servicios mecánicos/i, rep: "Mecánicos" },
      { pattern: /retail/i, rep: "Retail" },
      { pattern: /gastronom/i, rep: "Gastronomía" },
      { pattern: /hoteler/i, rep: "Hotelería" },
      { pattern: /turismo/i, rep: "Turismo" },
      { pattern: /fabricación de automotores/i, rep: "Automotores" },
      { pattern: /concesionaria de vehículos/i, rep: "Vehículos" },
      { pattern: /transporte terrestre de pasajeros/i, rep: "Transporte" },
      { pattern: /club de fútbol/i, rep: "Fútbol" },
      { pattern: /gimnasios/i, rep: "Gimnasios" },
      { pattern: /estudio legal[- ]contable/i, rep: "Legal" },
      { pattern: /pizzer(í|ia)/i, rep: "Pizzería" },
      { pattern: /artefactos de belleza/i, rep: "Belleza" },
      { pattern: /cuidados de ancianos/i, rep: "Cuidados" },
      { pattern: /área de sistemas/i, rep: "Sistemas" },
      { pattern: /estaciones de servicio/i, rep: "Servicio" },
      { pattern: /petrolera/i, rep: "Petrolera" },
      { pattern: /limpieza/i, rep: "Limpieza" },
      { pattern: /tienda de ropa/i, rep: "Ropa" },
      { pattern: /supermercado/i, rep: "Supermercado" },
      { pattern: /gomería/i, rep: "Gomería" },
      { pattern: /tanques aeronáuticos/i, rep: "Tanques" },
      { pattern: /black store/i, rep: "Tienda" },
      { pattern: /estudio contable/i, rep: "Contable" },
      { pattern: /chapa y pintura/i, rep: "Chapa" },
      { pattern: /estudio jurídico/i, rep: "Jurídico" },
      { pattern: /taller de motos/i, rep: "Motos" },
      { pattern: /constructora/i, rep: "Construcción" },
      { pattern: /restaurante( de comida)?/i, rep: "Restaurante" },
      { pattern: /taller mecánico/i, rep: "Mecánico" },
      { pattern: /financiera/i, rep: "Financiera" },
      { pattern: /panadería/i, rep: "Panadería" },
      { pattern: /naviera/i, rep: "Naviera" },
      { pattern: /sushi/i, rep: "Sushi" },
      { pattern: /verdulería/i, rep: "Verdulería" },
      { pattern: /pisos/i, rep: "Pisos" },
      { pattern: /seguros/i, rep: "Seguros" },
      { pattern: /salud/i, rep: "Salud" },
      { pattern: /educación/i, rep: "Educación" },
      { pattern: /finanzas/i, rep: "Finanzas" },
      { pattern: /logística/i, rep: "Logística" },
      { pattern: /marketing/i, rep: "Marketing" },
      { pattern: /manufactura/i, rep: "Manufactura" },
      { pattern: /telecomunicaciones/i, rep: "Telecomunicaciones" },
      { pattern: /automotriz/i, rep: "Automotriz" },
      { pattern: /energía/i, rep: "Energía" },
      { pattern: /agricultura/i, rep: "Agricultura" },
      { pattern: /minería/i, rep: "Minería" },
      { pattern: /bienes raíces/i, rep: "Bienes" },
      { pattern: /recursos humanos/i, rep: "Recursos" },
      { pattern: /entretenimiento/i, rep: "Entretenimiento" },
      { pattern: /deporte/i, rep: "Deporte" },
      { pattern: /seguridad privada/i, rep: "Seguridad" },
      { pattern: /ong/i, rep: "Social" },
      { pattern: /arquitectura/i, rep: "Arquitectura" },
      { pattern: /moda/i, rep: "Moda" },
      { pattern: /artes y cultura/i, rep: "Artes" },
      { pattern: /e[- ]?commerce/i, rep: "Ecommerce" }
    ];
  
    for (const mapping of mappings) {
      if (mapping.pattern.test(rubro)) {
        return mapping.rep;
      }
    }
    
    const firstWord = rubro.split(' ')[0];
    return firstWord.charAt(0).toUpperCase() + firstWord.slice(1);
  }
  